import { usePage } from "@/lib/content";
import { Reveal } from "@/components/site/Motion";
import { PageHero, CTABand, usePageTitle } from "@/components/site/Bits";

export default function ParaQuem() {
  usePageTitle("Para Quem Atuamos");
  const { sections: s } = usePage("para_quem");
  const items = Array.isArray(s.items) ? s.items : [];

  return (
    <>
      <PageHero title={s.hero_title || "Para Quem Atuamos"} text={s.hero_text} overline="Silva Cotan e Associados — Assessoria Jurídica" />

      <section className="bg-ivory">
        <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
          <Reveal>
            <p className="max-w-2xl font-display text-2xl leading-relaxed text-navy md:text-3xl">{s.intro_text}</p>
          </Reveal>
          <div className="mt-14 grid gap-5 md:grid-cols-6">
            {items.map((item, i) => (
              <Reveal key={i} delay={0.06 * i} className={i < 2 ? "md:col-span-3" : "md:col-span-2"}>
                <div className="flex h-full flex-col border border-navy/10 bg-white p-8 transition-colors duration-300 hover:border-gold md:p-10" data-testid={`publico-card-${i}`}>
                  <span className="font-display text-sm italic text-gold">0{i + 1}</span>
                  <h2 className="mt-3 font-display text-2xl text-navy">{item.title}</h2>
                  <p className="mt-4 text-sm leading-relaxed text-inkgray">{item.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand title="Suporte jurídico conforme as necessidades de cada cliente." button="Fale conosco" />
    </>
  );
}
